import { useState, useEffect, memo } from "react";
import { CSVLink } from "react-csv";
import AnimacionCarga from "./animacion_de_carga";
import TablaGenerica from "./tablas";
import { obtenerRondas } from "../../functions/consultas";
import BotonSOS from "./sos/boton_sos";
import "bootstrap-icons/font/bootstrap-icons.css";

const columnas = [
  { label: "Fecha y hora", key: "fecha_hora" },
  { label: "Razón social", key: "cliente" },
  { label: "Usuario", key: "usuario" },
  { label: "Descripción QR", key: "descripcion" },
  { label: "Latitud", key: "latitud" },
  { label: "Longitud", key: "longitud" }
];

const estiloCSV = { padding: "7px 14px", margin: 2, backgroundColor: "#c0392b", color: "#fff", borderRadius: 7, fontSize: "0.82rem", fontWeight: 500, textDecoration: "none" };

const ListadoRondas = memo(() => {
  const [datos, setDatos] = useState([]);
  const [cargando, setCargando] = useState(true);

  const capturarDatos = async () => {
    try {
      const data = await obtenerRondas();
      const lista = (Array.isArray(data) ? data : Object.values(data || {})).map(item => {
        const fecha = item.fecha || "";
        const hora = item.hora || "";
        let fecha_hora = fecha;
        if (hora) {
          const [hh, mi] = hora.split(":");
          const h = parseInt(hh, 10);
          const ampm = h >= 12 ? "PM" : "AM";
          const h12 = String(h % 12 || 12).padStart(2, "0");
          fecha_hora = `${fecha} ${h12}:${mi} ${ampm}`;
        }
        return { ...item, fecha_hora };
      });
      setDatos(lista);
    } catch (error) {
      console.error(error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { capturarDatos(); }, []);

  const botonesAccion = [
    { texto: "Abrir Ubicación", icono: "bi-geo-alt", accion: (fila) => {
        window.open(
          `https://www.google.com/maps/search/?api=1&query=${fila.latitud},${fila.longitud}`,
          "_blank"
        );
      }
    }
  ];

  return cargando ? (
    <AnimacionCarga />
  ) : (
    <>
      <TablaGenerica
        datos={datos}
        titulos={columnas.map(c => c.label.toUpperCase())}
        campos={columnas.map(c => c.key)}
        elementosPorPagina={5000}
        columnaOrdenInicial={0}
        direccionOrdenInicial="desc"
        botones={botonesAccion}
        contenidoExtra={
          <>
            <button onClick={capturarDatos} title="Refrescar"><i className="bi bi-arrow-clockwise" /></button>
            <CSVLink data={datos} headers={columnas} filename="listado_rondas.csv" separator=";" style={estiloCSV} title="Exportar"><i className="bi bi-download" /></CSVLink>
          </>
        }
      />

      <BotonSOS />
    </>
  );
});

export default ListadoRondas;
